import React from 'react';
import './Why.css';

export default function Why() {
  const features = [
    {
      icon: '/assets/FreeCancellation@2x.png',
      title: 'Book now, pay later',
      description: 'Free cancellation on most stays',
    },
    {
      icon: '/assets/Reviews@2x.png',
      title: '300M+ reviews from travellers',
      description: 'Get trusted information from guests like you',
    },
    {
      icon: '/assets/GeniusGenericGiftBox@2x.png',
      title: '2+ million properties worldwide',
      description: 'Hotels, guest houses, apartments, and more...',
    },
    {
      icon: '/assets/CustomerSupport@2x.png',
      title: 'Trusted 24/7 customer service',
      description: 'We\'re always here to help',
    },
  ];

  return (
    <section className="block why-section">
      <div className="container">
        <div className="section-head">
          <h2>Why Ammy Services?</h2>
        </div>
        <div className="features-grid">
          {features.map((feature, idx) => (
            <div key={idx} className="feature-card">
              <div className="feature-icon">
                <img src={feature.icon} alt={feature.title} onError={(e) => (e.target.style.display = 'none')} />
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
